import React, { useState } from 'react';
import { useReveal } from '../lib/useReveal';
import { PlusIcon, MinusIcon } from '../lib/icons';
const FAQS = [{
  q: '¿Necesito conocimientos previos?',
  a: 'No. La formación está diseñada para comenzar desde cero.'
}, {
  q: '¿La formación es online?',
  a: 'Sí. Todo el contenido es 100% digital.'
}, {
  q: '¿Incluye clases en vivo?',
  a: 'No. Está diseñada para avanzar completamente a tu ritmo.'
}, {
  q: '¿Incluye certificado?',
  a: 'Sí. Incluye certificado digital.'
}, {
  q: '¿Cuánto tiempo tengo acceso?',
  a: 'El acceso es ilimitado.'
}, {
  q: '¿Hay garantía?',
  a: 'Sí. Contás con garantía de satisfacción de 7 días.'
}];
function FAQItem({
  q,
  a,
  isOpen,
  onClick
}: {
  q: string;
  a: string;
  isOpen: boolean;
  onClick: () => void;
}) {
  return <div className="border border-[#d4af37]/15 rounded-xl bg-[#11152e] overflow-hidden transition-all duration-300" data-id="element-60">
      <button onClick={onClick} className="w-full flex items-center justify-between p-5 text-left focus:outline-none hover:bg-[#1a1f3d] transition-colors" data-id="element-61">
        <span className="text-[#f5f1e6] font-bold text-base md:text-lg pr-4" data-id="element-62">
          {q}
        </span>
        <div className={`flex-shrink-0 w-8 h-8 rounded-full flex items-center justify-center transition-colors ${isOpen ? 'bg-[#d4af37] text-[#0a0e1f]' : 'bg-[#1a1f3d] border border-[#d4af37]/20 text-[#d4af37]'}`} data-id="element-63">
          {isOpen ? <MinusIcon size={18} data-id="element-64" /> : <PlusIcon size={18} data-id="element-65" />}
        </div>
      </button>
      <div className={`transition-all duration-300 ease-in-out ${isOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-66">
        <div className="p-5 pt-0 text-[#cbd0e0] text-sm md:text-base leading-relaxed border-t border-[#ffffff]/5 mt-2" data-id="element-67">
          {a}
        </div>
      </div>
    </div>;
}
export function FAQSection() {
  const [ref, vis] = useReveal();
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-[#0a0e1f] py-5 md:py-10 px-5 sm:px-6 border-t border-[#ffffff]/5" data-id="element-68">
      <div className="container mx-auto max-w-3xl" data-id="element-69">
        <div ref={ref} className={`reveal text-center mb-6 ${vis ? 'is-visible' : ''}`} data-id="element-70">
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-serif font-bold text-[#f5f1e6]" data-id="element-71">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-3" data-id="element-72">
          {FAQS.map((faq, i) => <FAQItem key={i} q={faq.q} a={faq.a} isOpen={openIndex === i} onClick={() => setOpenIndex(openIndex === i ? null : i)} data-id="element-73" />)}
        </div>
      </div>
    </section>;
}